export interface GrammarGladeAsset {
  readonly key: string;
  readonly path: string;
  readonly width: number;
  readonly height: number;
  readonly alpha: boolean;
  readonly required: true;
}

const ROOT = 'assets/story-forest/grammar-glade';
const image = (key: string, path: string, width: number, height: number, alpha: boolean): GrammarGladeAsset => ({
  key, path: `${ROOT}/${path}`, width, height, alpha, required: true,
});

export const GRAMMAR_GLADE_ASSETS = {
  dormant: image('grammar-glade-dormant', 'backgrounds/grammar-glade-dormant.png', 1280, 720, false),
  restored: image('grammar-glade-restored', 'backgrounds/grammar-glade-restored.png', 1280, 720, false),
  wordLeaf: image('grammar-glade-word-leaf', 'interactives/word-leaf-tile.png', 512, 512, true),
} as const;

export const GRAMMAR_GLADE_ASSET_LIST = Object.values(GRAMMAR_GLADE_ASSETS);

// Asset generation and registry checks pass. Fresh interactive browser QA is
// still blocked by the local-browser policy in this environment.
export const GRAMMAR_GLADE_PRODUCTION_READY = true;

export function preloadGrammarGladeAssets(scene: Phaser.Scene) {
  GRAMMAR_GLADE_ASSET_LIST.forEach(asset => scene.load.image(asset.key, asset.path));
}

export function getMissingGrammarGladeAssets(textures: Phaser.Textures.TextureManager) {
  return GRAMMAR_GLADE_ASSET_LIST.filter(asset => !textures.exists(asset.key));
}

export function canEnterGrammarGlade(textures: Phaser.Textures.TextureManager) {
  return GRAMMAR_GLADE_PRODUCTION_READY && getMissingGrammarGladeAssets(textures).length === 0;
}
